import { useEffect } from "react";
import type { G_GetRecommendedVideoQuery } from "~/lib/graphql";
import { QUANTITY_NUMBER, TRACKING_EVENT_TYPES, TRACKING_PRICE } from "~/lib/tracking/const";
import { sendTrackingViewItemList } from "~/lib/tracking/events";

type Arg = {
  recommendedVideos: G_GetRecommendedVideoQuery["video"]["i2iRecommendedVideos"]["edges"];
  trackingId: string | undefined;
  testId: string | undefined;
  requestId: string | undefined;
};

export const useRecommendationViewItemList = ({ recommendedVideos, trackingId, testId, requestId }: Arg) => {
  const productDetails = recommendedVideos.map(({ node }, idx) => {
    const { id, titleName } = node.video;

    return {
      product: {
        id,
        index: idx + 1,
        item_name: titleName,
        priceInfo: { price: TRACKING_PRICE },
      },
      quantity: QUANTITY_NUMBER,
    };
  });

  useEffect(() => {
    if (productDetails.length === 0) return;
    sendTrackingViewItemList(
      productDetails,
      TRACKING_EVENT_TYPES["CATEGORY_PAGE_VIEW"],
      null,
      "recommend",
      trackingId,
      testId,
      requestId
    );
  }, [productDetails.length]);
};
